import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { PermissionService } from './permission.service';
import { Action } from './permission.model';

@Directive({ selector: '[appCan]', standalone: false })
export class CanDirective implements OnInit {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private permissionService = inject(PermissionService);

  @Input() appCan!: Action;
  @Input() appCanElse?: TemplateRef<unknown>;

  ngOnInit(): void {
    this.viewContainer.clear();
    if (this.permissionService.can(this.appCan)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.appCanElse) {
      this.viewContainer.createEmbeddedView(this.appCanElse);
    }
  }
}
